import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useTranslation } from 'react-i18next';

const FAQSection = () => {
  const { t } = useTranslation();
  const faqIds = ['yoast', 'lifetime', 'credits', 'creditsCost', 'sites', 'whichAi', 'trial', 'b2b', 'languages', 'aeo', 'integrations', 'widget'];

  return (
    <section id="faq" className="py-24 px-6 bg-[#0a0a0a]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16 animate-fade-up">
          <span className="text-xs uppercase tracking-[0.2em] text-[#0055FF] font-semibold">FAQ</span>
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-medium tracking-tight mt-4 mb-6">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-[#A1A1AA]">{t('faq.subtitle')}</p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqIds.map((id, index) => (
            <AccordionItem
              key={id}
              value={`item-${id}`}
              className="bg-[#111111] border border-white/10 rounded-2xl px-6 data-[state=open]:border-[#0055FF]/30"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="text-left font-['Outfit'] font-medium hover:no-underline py-6 text-white">
                {t(`faq.entries.${id}.q`)}
              </AccordionTrigger>
              <AccordionContent className="text-[#A1A1AA] pb-6 leading-relaxed whitespace-pre-line">
                {t(`faq.entries.${id}.a`)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center animate-fade-up">
          <p className="text-[#A1A1AA] mb-4">{t('faq.contactPrompt')}</p>
          <a
            href="mailto:support@aeo-orchestra.com"
            className="text-[#0055FF] hover:text-[#3377FF] font-medium transition-colors"
          >
            {t('faq.contactCta')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
